// context/CompanyConfigContext.tsx
import { createContext, useContext } from 'react';

export const CompanyConfigContext = createContext(null);

export const useCompanyConfig = () => {
  return useContext(CompanyConfigContext);
};
